export const MOBILE_CHANNEL = 'mobile';
export const DELIMITER = ':';
export const SCREENS = {
  LOADING: 'LOADING',
  ADD_TO_QUOTE_FORM: 'ADD_TO_QUOTE_FORM',
  CREATE_NEW_QUOTE: 'CREATE_NEW_QUOTE',
  ERROR_SCREEN: 'ERROR_SCREEN',
  SIGN_IN: 'SIGN_IN',
  SUCCESS: 'SUCCESS'
};
export const GENERIC_ERROR = 'Something went wrong. Please refresh and try again.';
export const PRODUCT_LIMIT_ERROR = `We're sorry, you've exceeded the maximum number of items (89) 
allowed in a quote. Select fewer items and try again or create a new quote.`;
export const DEFAULT_SELECTED_QUOTE = {
  userId: '', // this needs to be the userId of the user that created the quote, not current user
  quoteId: '',
  quoteName: ''
};

export const ERROR = {
  // eslint-disable-next-line max-len
  INVALID_QUOTE_NAME: 'Invalid Quote Name: Only a-z, A-Z, 0-9 are allowed.',
  EMPTY_QUOTE_NAME: 'Quote name cannot be empty'
};

export const QUOTE_ACTIVE_STATUS = 'ACTIVE';
export const QUOTE_PENDING_STATUS = 'PENDING';

export const FULFILLMENT = {
  STH: 'ShipToHome',
  BOPIS: 'BOPIS',
  BOSS: 'ShipToStore',
  BODFS: 'DeliverFromStore',
  APPLIANCE: 'DirectDelivery'
};
export const PICKUP_FULFILLMENT = [FULFILLMENT.BOSS, FULFILLMENT.BOPIS];
export const DELIVERY_FULFILLMENT = [FULFILLMENT.STH, FULFILLMENT.BODFS, FULFILLMENT.APPLIANCE];

// role
export const USER_ADMIN = 'ADMIN';
export const PURCHASER = 'PURCHASER';

// Product Exceptions Constants
export const ITEMS_CANNOT_BE_QUOTED_MESSAGE = `item(s) weren't added to your quote. Please copy and share 
these items with your Home Depot Pro Associate for assistance.`;
export const ADDITIONAL_HANDLING_MESSAGE = `The following product(s) require additional handling by a Home 
Depot Pro Associate to quote or purchase at this time.`;
export const ADDITIONAL_ASSISTANCE_MESSAGE = `The following product(s) may be purchased online, but require  
assistance from a Home Depot Pro Associate to quote at this time.`;
export const DISCONTINUED_OOS_MESSAGE = `The following product(s) are either discontinued or out of stock. 
Contact your Home Depot Pro Associate for additional options.`;
export const UNAVAILABLE_MESSAGE = `other product(s) are missing information and are unavailable for quote 
or purchase at this time.`;
export const COPY_SUCCESS = 'Successfully copied to clipboard';
export const COPY_ERROR = `An error has occurred. Please try copying item details to clipboard 
again or refresh the page.`;

// Analytics Constants
export const CREATE_A_QUOTE_BACK_BUTTON = 'create a quote overlay: back button';
export const CREATE_A_QUOTE_X_OR_CANCEL_BUTTON = 'create a quote overlay: x or cancel or outside click button';
export const CREATE_A_QUOTE_CLOSE_BUTTON = 'create a quote overlay: quote created: close button';

export const ADD_TO_QUOTE_X_OR_CANCEL_BUTTON = 'add to quote overlay: x or cancel or outside click button';
export const ADD_TO_QUOTE_CLOSE_BUTTON = 'add to quote overlay: quote created: close button';

// Quote Name Constants
export const QUOTE_NAME_MAX_LENGTH = 50;

// New ATQ UI Constants
// Quote list page size: first page, and the step for Show More / Show Less
export const NEW_UI_QUOTES_PAGE_SIZE = 10;
export const LEGACY_QUOTES_PAGE_SIZE = 20;
export const NEW_QUOTE_OPTION = 'NEW_QUOTE';
export const QUOTE_HAS_APPLIANCE_MESSAGE = 'This item can\'t be added to a quote that contains an appliance.';
export const QUOTE_HAS_GM_MESSAGE = 'Major appliances can only be added to appliance-only quotes.';
export const QUOTE_SELECTION_RADIO_GROUP_NAME = 'quote-selection';
export const MA_TOTAL_QTY_ERR_MSG = 'You can only add 12 appliances per quote. '
  + 'Choose another quote or create a new quote.';
export const SKU_QTY_LIMIT_MSG = 'You can only add 6 of this item per quote. '
  + 'Choose another quote or create a new quote.';
export const QUOTE_ERROR_MESSAGES = {
  CART_ERR_124: MA_TOTAL_QTY_ERR_MSG,
  CART_ERR_125: SKU_QTY_LIMIT_MSG
};
